import { Mark } from "@mashriqain/ui";

/** Shown for the instant the first page's code is loading. */
export function Splash() {
  return (
    <div style={{ minHeight: "100svh", display: "grid", placeItems: "center", color: "var(--text)" }}>
      <Mark size={64} title="Mashriqain" />
    </div>
  );
}
